module.exports = __webpack_public_path__ + "img/loading.8a7630ca.gif";